import type { PrescriptionRefill } from '../../store/prescriptionsSlice'

interface RefillHistoryProps {
  refills: PrescriptionRefill[]
  totalRefills: number
  remainingRefills: number
}

export function RefillHistory({ refills, totalRefills, remainingRefills }: RefillHistoryProps) {
  const isZeroRemaining = remainingRefills === 0

  return (
    <div data-testid="refill-history-section" className="border border-border rounded-[6px] bg-surface">
      <div className="px-4 py-3 border-b border-border flex items-center justify-between">
        <h2 className="text-[14px] font-medium text-text-primary">Refill History</h2>
        <span
          data-testid="refill-count-display"
          className={`text-[12px] font-medium ${
            isZeroRemaining ? 'text-status-error' : 'text-text-muted'
          }`}
        >
          {remainingRefills} of {totalRefills} refills remaining
        </span>
      </div>
      <div className="p-4">
        {refills.length === 0 ? (
          <p className="text-[13px] text-text-muted" data-testid="refill-empty-state">
            No refills recorded yet
          </p>
        ) : (
          <div className="grid grid-cols-1" data-testid="refill-history-table">
            <div className="rh-table-header grid grid-cols-4 h-9 items-center text-[12px] font-medium text-text-muted border-b border-border-light">
              <span>Date</span>
              <span>Quantity Dispensed</span>
              <span>Dispensed By</span>
              <span>Notes</span>
            </div>
            {refills.map((refill) => (
              <div
                key={refill.id}
                data-testid="refill-history-row"
                className="rh-table-row grid grid-cols-4 h-11 items-center text-[13px] text-text-primary hover:bg-hover transition-colors duration-100"
              >
                <span>{refill.refill_date}</span>
                <span>{refill.quantity_dispensed}</span>
                <span>{refill.dispensed_by || '—'}</span>
                <span className="text-text-muted">{refill.notes || '—'}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
